export const offerTypes = [
	{ "value":"sale-new", "label":"Vendita nuovo", "initials":"VN" },
	{ "value":"sale-used", "label":"Vendita usato", "initials":"VU" },
	{ "value":"rent-daily", "label":"Noleggio giornaliero", "initials":"NG" },
	{ "value":"rent-monthly", "label":"Noleggio mensile", "initials":"NM" }
]

export const offerStatus = [
	{ "value":"waiting", "label":"In attesa" },
	{ "value":"accepted", "label":"Accettata", "offerLocked":true },
	{ "value":"refused", "label":"Rifiutata", "lost":true, "offerLocked":true }
]

export const rentPeriodTypes = [
	{ "value":"day", "label":"Giorno" },
	{ "value":"month", "label":"Mese" }
]

export const transportTypes = [
	{ "value":"socar", "label":"Trasporto Socar" },
	{ "value":"semitrailer", "label":"Bilico" }
]

export const currentYear = new Date().getFullYear()
export const yearsOptions = Array.from(
	{ length: currentYear - 2020 },
	(_, i) => currentYear - i - 1
).map(year => ({
	value: year.toString(),
	label: year.toString()
}))
